import React from 'react';

import { Container, ContainerProps } from '@lglp/components';

import { getSingleTypeDocument } from '../../../actions/prismic';
import loading, { withThunk } from '../../../helpers/loading';
import { useSingleType } from '../../../hooks';
import { SSRComponent } from '../../../types/component';
import { DocumentType } from '../../../types/document';
import { DesktopLayout } from './DesktopMenu';
import styles from './Header.module.scss';
import { MobileLayout } from './MobileMenu';

export const Header: SSRComponent<ContainerProps> = ({
  className,
  ...rest
}) => {
  const { data } = useSingleType(DocumentType.HEADER);

  return (
    <Container className={[className, styles.header]} {...rest}>
      <DesktopLayout menuItems={data?.mainMenu} searchMenu={data?.searchMenu} />
      <MobileLayout menuItems={data?.mainMenu} searchMenu={data?.searchMenu} />
    </Container>
  );
};

Header.getInitialProps = (data) =>
  loading(data, withThunk(getSingleTypeDocument(DocumentType.HEADER)));
